import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider, ThemeProvider, CurrencyProvider, EncryptionProvider, ProfileProvider } from '@/contexts'
import { PWAUpdatePrompt } from '@/components/common'
import { router } from '@/router'
import { invitationService } from '@/services/invitation.service'
import '@/config/i18n.config'

// Create a query client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

/**
 * Fetch wrapped DEK from backend for encryption unlocking.
 * Called by EncryptionProvider when user enters passphrase.
 */
const fetchWrappedDEK = async () => {
  return invitationService.getDEK()
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <CurrencyProvider>
          <AuthProvider>
            <EncryptionProvider fetchWrappedDEK={fetchWrappedDEK}>
              <ProfileProvider>
                <RouterProvider router={router} />
                <PWAUpdatePrompt />
              </ProfileProvider>
            </EncryptionProvider>
          </AuthProvider>
        </CurrencyProvider>
      </ThemeProvider>
    </QueryClientProvider>
  )
}

export default App
